import React from 'react';
import ExampleBlock from './example-block';
import Guidelines from './Guidelines';
import LogoClearspace from 'assets/images/aptitude/logo-clearspace.svg';
import styles from './logo.module.scss';
import PrimaryLogo from 'shared/img/primary-logo.svg';
import BlueLogo from 'shared/img/primary-logo-blue.svg';
import StackedLogo from 'shared/img/primary-stacked-logo.svg';

const Logo = () => (
  <section className={styles.section}>
    <header>
      <h1 id="logo">Logo</h1>
    </header>
    <div className={styles.logoDownloadContainer}>
      <div className={styles.logoDownload}>
        <BlueLogo width={300} />
        <a
          href="https://d2w40dx4mhyr32.cloudfront.net/zip/RaiseMe-Logos.zip"
          className={styles.downloadLink}
        >
          Download Logo
        </a>
      </div>
    </div>

    <h2>Logo</h2>
    <hr />
    <div className={styles.logoGrid}>
      <ExampleBlock
        className={styles.exampleBlock}
        background="blue"
        text="Raise Me primary horizontal logo."
      >
        <PrimaryLogo width={300} />
      </ExampleBlock>
      <ExampleBlock className={styles.exampleBlock} background="blue" text="Raise Me stacked logo.">
        <StackedLogo width={150} />
      </ExampleBlock>
    </div>

    <h2 className={styles.clearspaceHeader}>Clearspace</h2>
    <hr />
    <ExampleBlock
      text={`Our logo should always have space to breathe.
        We call this its "clearspace." Please do not
        place things inside of it.`}
    >
      <LogoClearspace height={175} />
    </ExampleBlock>

    <h2>Logo Guidelines</h2>
    <hr />
    <div className={styles.logoGrid}>
      <Guidelines />
    </div>
  </section>
);

export default Logo;
